import Footer from '../../components/footer/Footer';
import Navbar from '../../components/navbar/Navbar';

export default function TermsOfService() {
    return (
        <div style={{ width: '100%', height: '100%' }}>
            <Navbar />
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        width: '80%',
                        backgroundColor: 'white',
                        padding: '2rem',
                        boxSizing: 'border-box',
                        marginBottom: '1rem',
                    }}
                >
                    <meta
                        httpEquiv="Content-Type"
                        content="text/html; charset=utf-8"
                    />
                    <meta
                        name="Generator"
                        content="Microsoft Word 15 (filtered)"
                    />
                    <style
                        dangerouslySetInnerHTML={{
                            __html: '\n<!--\n /* Font Definitions */\n @font-face\n\t{font-family:Helvetica;\n\tpanose-1:0 0 0 0 0 0 0 0 0 0;}\n@font-face\n\t{font-family:Wingdings;\n\tpanose-1:5 0 0 0 0 0 0 0 0 0;}\n@font-face\n\t{font-family:"Cambria Math";\n\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n@font-face\n\t{font-family:Calibri;\n\tpanose-1:2 15 5 2 2 2 4 3 2 4;}\n@font-face\n\t{font-family:"Noto Sans Symbols";\n\tpanose-1:2 11 6 4 2 2 2 2 2 4;}\n@font-face\n\t{font-family:Georgia;\n\tpanose-1:2 4 5 2 5 4 5 2 3 3;}\n /* Style Definitions */\n p.MsoNormal, li.MsoNormal, div.MsoNormal\n\t{margin:0in;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;}\nspan.MsoHyperlink\n\t{color:blue;\n\ttext-decoration:underline;}\np\n\t{margin-right:0in;\n\tmargin-left:0in;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;}\np.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:.5in;\n\tfont-size:12.0pt;\n\tfont-family:"Calibri",sans-serif;}\np.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:.5in;\n\tfont-size:12.0pt;\n\tfont-family:"Calibri",sans-serif;}\np.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:.5in;\n\tfont-size:12.0pt;\n\tfont-family:"Calibri",sans-serif;}\np.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:.5in;\n\tfont-size:12.0pt;\n\tfont-family:"Calibri",sans-serif;}\nspan.apple-converted-space\n\t{mso-style-name:apple-converted-space;}\n /* Page Definitions */\n @page WordSection1\n\t{size:8.5in 11.0in;\n\tmargin:1.0in 1.0in 1.0in 1.0in;}\ndiv.WordSection1\n\t{page:WordSection1;}\n /* List Definitions */\n ol\n\t{margin-bottom:0in;}\nul\n\t{margin-bottom:0in;}\n-->\n',
                        }}
                    />
                    <div className="WordSection1">
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'center' }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '15.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Reffy Inc.
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'center' }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '15.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Terms of Service
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '24.0pt',
                                marginRight: '0in',
                                marginBottom: '6.0pt',
                                marginLeft: '0in',
                                textAlign: 'center',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Last Updated: May 16, 2023
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span style={{ fontSize: '11.0pt' }}>
                                Welcome to Reference Builder at
                                https://refbuilder.com (the “
                                <b>
                                    <i>Site</i>”
                                </b>
                                ), which is owned and operated by Reffy Inc.,{' '}
                            </span>
                            <span lang="EN" style={{ fontSize: '11.0pt' }}>
                                a Delaware Corporation
                            </span>
                            <span style={{ fontSize: '11.0pt' }}>
                                {' '}
                                and our affiliated entities{' '}
                                <span style={{ color: '#444444' }}>
                                    (“
                                    <b>
                                        <i>Reffy</i>
                                    </b>
                                    ”, “
                                    <b>
                                        <i>Company</i>
                                    </b>
                                    ”, “
                                    <b>
                                        <i>we</i>
                                    </b>
                                    ”, “
                                    <b>
                                        <i>our</i>
                                    </b>
                                    ” or “
                                    <b>
                                        <i>us</i>
                                    </b>
                                    ”) and governs your right to use the Site.
                                    These terms of service (this “
                                    <b>
                                        <i>Agreement</i>
                                    </b>
                                    ” or these “
                                    <b>
                                        <i>Terms</i>
                                    </b>
                                    ”) form a binding agreement between you as a
                                    user (“
                                    <b>
                                        <i>you</i>
                                    </b>
                                    ” or “
                                    <b>
                                        <i>your</i>
                                    </b>
                                    ”) and us and shall be the equivalent of a
                                    written paper agreement between you and us.
                                    If you open an account on the Reffy Platform
                                    on behalf of an organization or other
                                    entity, then “
                                    <b>
                                        <i>you</i>
                                    </b>
                                    ” includes you and that entity, and you
                                    represent and warrant that you are an
                                    authorized representative of the entity with
                                    the authority to bind the entity to these
                                    Terms, and that you agree to these Terms on
                                    the entity’s behalf. The effective date of
                                    this Agreement is when you accept or are
                                    deemed to accept this Agreement as discussed
                                    below.
                                </span>
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                We are excited to provide a platform to
                                streamline the process of requesting, drafting,
                                and sending reference letters or other
                                evaluations on behalf of candidates for
                                educational, professional, and other
                                opportunities.&nbsp; &nbsp;&nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '12.0pt',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '0in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                These Terms apply to your use of the Services
                                and software provided on our Site, any other
                                services, content, communications, and offerings
                                relating to the Site, and as set forth in these
                                Terms (the “
                                <b>
                                    <i>Reffy Platform</i>
                                </b>
                                ”).
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '12.0pt',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '0in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                NOTE: THESE TERMS CONTAIN A BINDING ARBITRATION
                                PROVISION WITH A CLASS ACTION WAIVER AND A
                                WAIVER OF THE RIGHT TO A JURY. PLEASE REVIEW{' '}
                                <u>SECTION 27</u> BELOW BEFORE DOWNLOADING OR
                                USING THE REFFY PLATFORM.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '12.0pt',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '0in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                We reserve the right to make modifications to
                                these Terms at any time and for any reason.
                                Please check these Terms regularly to ensure you
                                are aware of any modifications made by us. By
                                continuing to access or use the Reffy Platform
                                after those revisions become effective, you
                                agree to be bound by the revised Terms. If you
                                do not agree to these Terms, you must
                                immediately stop using the Reffy Platform.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    1.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Platform
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . The Reffy Platform enables users (“
                                <b>
                                    <i>Users</i>
                                </b>
                                ”) to offer, search for, and request reference
                                letter drafting services or other forms of
                                personal and professional evaluation for usage
                                in academic, professional, and other settings
                                (the “
                                <b>
                                    <i>Services</i>
                                </b>
                                ”). Users who use the Reffy Platform to provide
                                drafting services are “
                                <b>
                                    <i>Writers</i>
                                </b>
                                ”, and Users who use the Reffy Platform to
                                search for or request Services are “
                                <b>
                                    <i>Recipients</i>
                                </b>
                                .” Recipients provide information to Writers
                                using the Reffy Platform but do not create
                                accounts. To qualify as a Writer and have access
                                to the Reffy Platform, you must first create an
                                account pursuant to Section 4 below. Subject to
                                these Terms, we provide the Reffy Platform
                                including hosting and maintaining the Site,
                                facilitating the Services provided for Users.
                                You acknowledge that we do not supervise,
                                direct, control, or monitor Writers in
                                performance of any Services and you agree that:
                                (a) Reffy is not responsible for ensuring the
                                accuracy or legality of any user Content (as
                                defined herein), for which Users are solely
                                responsible; (b) Reffy does not make any
                                representations about or guarantee any
                                particular outcome as a result of using the
                                Reffy Platform; and (c) nothing will create an
                                employment, agency, or joint venture
                                relationship between Reffy and any Writer
                                offering Services on the Reffy Platform.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                        background: 'white',
                                    }}
                                >
                                    2.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Acknowledgement and Disclaimers
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . By using the Reffy Platform, you acknowledge
                                and agree{' '}
                                <span style={{ background: 'white' }}>
                                    that Recipients, and not Reffy, are solely
                                    responsible for (a) evaluating and
                                    determining the suitability of any Writer
                                    for Services; (b) verifying any information
                                    about another User; and (c) deciding whether
                                    to request Services on the Reffy Platform.
                                    Reffy is not party to any agreements between
                                    Users on the Reffy Platform.{' '}
                                </span>
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    3.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Privacy
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . By accessing or using the Reffy Platform, you
                                intend to and expressly agree to be bound by all
                                the terms and conditions of this Agreement and
                                our Privacy Policy (available at
                            </span>
                            <span style={{ fontSize: '11.0pt' }}> </span>
                            <a href="https://refbuilder.com/terms-of-service">
                                <span style={{ fontSize: '11.0pt' }}>
                                    https://refbuilder.com/terms-of-service
                                </span>
                            </a>
                            <span style={{ fontSize: '11.0pt' }}>)</span>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                (the “
                                <b>
                                    <i>Privacy Policy</i>
                                </b>
                                ”), which is incorporated herein by reference.
                                If you do not agree to these terms and
                                conditions, you may not use the Reffy Platform.
                                Any information that you provide to us is
                                subject to the Privacy Policy, which governs our
                                collection and use of your information. You
                                understand that through your use of the Reffy
                                Platform you consent to the collection and use
                                of your information as set forth in the Privacy
                                Policy.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    4.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Accounts.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                {' '}
                                Writers must register an account to access and
                                use the features of the Reffy Platform. By
                                registering to use the Reffy Platform, you
                                represent and warrant that you: &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                If an individual, are of legal age;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Are legally qualified to enter a binding
                                contract with us;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Are not prohibited by law from using the Reffy
                                Platform;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Have not submitted information in the
                                registration process that is inaccurate or
                                untruthful;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Do not have more than one account on the Reffy
                                Platform; and
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Have not previously been removed from the Reffy
                                Platform by us, unless you have our express
                                written permission to create a new account.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Are legally permitted to use and access the
                                Reffy Platform and take full responsibility for
                                the selection and use of and access to the Reffy
                                Platform.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Moreover, you agree to provide accurate,
                                current, and complete information during
                                registration in addition to keeping your account
                                information up-to-date. You may not register
                                more than one account or transfer your account
                                to someone else. You are responsible for
                                maintaining the confidentiality and security of
                                your account credentials and may not disclose
                                your credentials to any third party. You are
                                responsible and liable for activities conducted
                                through your account and must immediately notify
                                Reffy if you suspect that your credentials have
                                been lost, stolen, or your account is otherwise
                                compromised. If and as permitted by applicable
                                law, we may, but have no obligation to (a) ask
                                you to provide identification or other
                                information, (b) undertake checks designed to
                                help verify your identity or background, (c)
                                screen you against third-party databases or
                                other sources and request reports from service
                                providers.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                If at any time you cease to meet these
                                requirements, we reserve the right to delete
                                your account with us, to revoke all credentials
                                held by you and to delete all Content uploaded
                                by you to the Reffy Platform.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.5in',
                                textAlign: 'justify',
                                border: 'none',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    5.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Authorized Users
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . Depending on your subscription level to our
                                Reffy Platform, we may authorize you to grant
                                other individuals within your organization
                                access to the Reffy Platform from time to time
                                (each, an “
                                <b>
                                    <i>Authorized User</i>
                                </b>
                                ”). You are solely responsible for Authorized
                                User activities and interaction with the Reffy
                                Platform. You agree to ensure all Authorized
                                Users are aware of all restrictions of use in
                                these Terms, the Privacy Policy, and any other
                                rules or requirements applicable to the Reffy
                                Platform. You agree to cause Authorized Users to
                                comply with such provisions. You are solely
                                responsible for all actions taken by and
                                interactions with Authorized Users, including
                                providing any disclosures governing an
                                Authorized User’s interaction with the Reffy
                                Platform, and any applicable Privacy Policy or
                                further obligations required by us or any
                                applicable law. Any obligation imposed on you by
                                these Terms shall be applicable to you and to
                                any Authorized User.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    6.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Recipient Terms
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                .{' '}
                            </span>
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                You, as a Recipient, can use the Reffy Platform
                                to connect with, and request Writers to perform
                                Services. When you request Services as a
                                Recipient, you are agreeing to provide the
                                Writer with access to all information previously
                                inputted by you into the Reffy Platform.{' '}
                            </span>
                        </p>
                        <p
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '0in',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '0in',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                In general, if as a Recipient you wish to cancel
                                your request for Services, you must contact each
                                Writer that has provided you with Services and
                                provide them with all details they request to
                                cancel your request prior to the completion of
                                Services by the applicable Writer. You
                                acknowledge and agree that once a reference
                                letter has been sent by a Writer to a
                                third-party on your behalf, that Reffy will be
                                unable to cancel the request and you are fully
                                responsible for contacting the applicable
                                third-party.{' '}
                            </span>
                        </p>
                        <p
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '0in',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '0in',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                You are responsible and liable for your own acts
                                and omissions. Additionally, (a) you are
                                responsible for providing Writers with accurate,
                                truthful, and complete information related to
                                the Services, and (b) you must act with
                                integrity, treat others with respect, and comply
                                with applicable laws at all times.{' '}
                            </span>
                        </p>
                        <p style={{ margin: '0in', textAlign: 'justify' }}>
                            <b>
                                <span style={{ fontSize: '11.0pt' }}>
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '0in',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <b>
                                <span style={{ fontSize: '11.0pt' }}>
                                    You further acknowledge that Reffy does not
                                    control nor does it have knowledge of the
                                    validity of any Writer credentials and/or
                                    the competency of any Writers on the Reffy
                                    Platform, or the outcomes of sending
                                    reference letters drafted using the Reffy
                                    Platform to third-parties. It is your
                                    responsibility to investigate the Writers on
                                    the Reffy Platform to determine whether they
                                    are suitable for your use.{' '}
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    7.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Writer Terms
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                .
                            </span>
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                The Reffy Platform provides tools that make it
                                easy for you, as a Writer, to manage and draft
                                reference letters{' '}
                            </span>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                or other forms of personal and professional
                                evaluations{' '}
                            </span>
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                for Recipients. Once you have created an account
                                on the Reffy Platform you will have access to a
                                webpage on the Site where you will be able to
                                view requests for Services, set various
                                requirements and parameters for Recipients
                                before reference letters are drafted, and
                                provide general biographical information about
                                yourself for Recipients to review (the “
                                <b>
                                    <i>Writer Account Page</i>
                                </b>
                                ”).
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                Your Writer Account Page must include complete
                                and accurate information about yourself, and any
                                rules or parameters that you have chosen to
                                display to Recipients requesting Services. You
                                are responsible for keeping the content on your
                                Writer Account Page up-to-date and accurate at
                                all times. You are also responsible for ensuring
                                that the parameters or content that you include
                                on your Writer Account Page does not violate
                                these Terms.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#222222' }}
                            >
                                You are responsible for understanding and
                                complying with any laws, rules, regulations, and
                                contracts with third parties that apply to your
                                Writer Account Page and the Services provided as
                                a Writer on the Reffy Platform.
                                <span className="apple-converted-space">
                                    &nbsp;
                                </span>
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#222222',
                                        background: 'white',
                                    }}
                                >
                                    You acknowledge that as a Writer you are
                                    responsible and liable for your own acts and
                                    omissions and are also responsible for the
                                    acts and omissions of anyone you allow to
                                    participate in the Services offered on your
                                    Writer Account Page. You are responsible for
                                    establishing rules and parameters for the
                                    Services you provide via the Reffy Platform,
                                    including but not limited to ensuring that
                                    the content on the Writer Account Page does
                                    not violate these Terms. &nbsp;You are also
                                    responsible for verifying the accuracy of
                                    the information contained in the applicable
                                    reference letter or professional
                                    recommendation prior to sending the
                                    applicable letter or recommendation to any
                                    third parties. You may not collect any fees
                                    or charges from Recipients.{' '}
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    8.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Content.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                {' '}
                                Parts of the Reffy Platform enable you, or your
                                Authorized Users to provide feedback, text,
                                photos, information, and other content
                                (collectively, “
                                <b>
                                    <i>Content</i>
                                </b>
                                ”). By providing Content, in whatever form and
                                through whatever means, you, or your Authorized
                                Users, grant Reffy a non-exclusive, worldwide,
                                royalty-free, irrevocable, perpetual,
                                sub-licensable and transferable license to copy,
                                modify, prepare derivative works of, distribute,
                                and otherwise exploit, that Content, without
                                limitation. If Content includes personal
                                information, our Privacy Policy&nbsp;describes
                                how we use that personal information. You are
                                solely responsible for all Content that you, or
                                your Authorized Users, provide and warrant that
                                you either own it or are authorized to grant
                                Reffy the rights described in these Terms. You
                                are responsible and liable if any of your, or
                                your Authorized User’s Content violates or
                                infringes the intellectual property or privacy
                                rights of any third party.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                You hereby represent and warrant that any
                                Content you, or your Authorized Users provide:{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoListParagraphCxSpFirst"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: '"Times New Roman",serif',
                                    color: '#444444',
                                }}
                            >
                                Is not created solely for the purpose of
                                advertising or other commercial content,
                                including company logos, links or company names;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoListParagraphCxSpMiddle"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: '"Times New Roman",serif',
                                    color: '#444444',
                                }}
                            >
                                Does not contain spam, unwanted contact, or
                                content that is shared repeatedly in a
                                disruptive manner;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoListParagraphCxSpMiddle"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: '"Times New Roman",serif',
                                    color: '#444444',
                                }}
                            >
                                Does not endorse or promote illegal or harmful
                                activity, is not sexually explicit, violent,
                                graphic, threatening, or harassing;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoListParagraphCxSpMiddle"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: '"Times New Roman",serif',
                                    color: '#444444',
                                }}
                            >
                                Does not attempt to impersonate another person,
                                account, or entity, including a representative
                                of Reffy;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoListParagraphCxSpMiddle"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: '"Times New Roman",serif',
                                    color: '#444444',
                                }}
                            >
                                Is not illegal and does not violate another
                                person's or entity's rights, including
                                intellectual property rights and privacy rights;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoListParagraphCxSpLast"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: '"Times New Roman",serif',
                                    color: '#444444',
                                }}
                            >
                                Does not contain another person's private or
                                confidential information, including content that
                                is sufficient to identify a listing's location.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                You agree to defend, indemnify, and hold us
                                harmless for all damage or liability we incur
                                because of your violation of this Section.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    9.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Artificial Intelligence Technology
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . You acknowledge that the Reffy Platform uses
                                artificial intelligence technology (“
                            </span>
                            <b>
                                <i>
                                    <span
                                        style={{
                                            fontSize: '11.0pt',
                                            color: '#444444',
                                        }}
                                    >
                                        AI
                                    </span>
                                </i>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                ”) to provide the Services. You acknowledge that
                                the quality of products created using the Reffy
                                Platform will be limited by the quality of
                                information provided by Recipients. AI{' '}
                            </span>
                            <span style={{ fontSize: '11.0pt' }}>
                                is a rapidly evolving field meaning that the use
                                of the Services may, in some situations, result
                                in occasional incorrect outputs that do not
                                accurately reflect the information inputted. You
                                are responsible for evaluating and reviewing the
                                accuracy of any such output as appropriate for
                                your use case, including by using human review
                                of the output.{' '}
                            </span>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    10.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Compliance with Laws
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . You agree to provide and/or use the Reffy
                                Platform only for lawful purposes, and to
                                conduct your business on the Reffy Platform, in
                                accordance with all applicable laws and
                                regulations. You will not use the Reffy Platform
                                for any fraudulent or illegal activity.{' '}
                            </span>
                        </p>
                        <p className="MsoNormal">
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#0A0B0D',
                                        background: 'white',
                                    }}
                                >
                                    11.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Fees; Payment Processing.{' '}
                                </span>
                            </b>
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    color: '#0A0B0D',
                                    background: 'white',
                                }}
                            >
                                In general, Reffy makes money by charging fees
                                to Users for the right to use the Reffy
                                Platform. We also facilitate the payment of
                                certain fees on the Reffy Platform. The amount
                                of our fees and charges may be disclosed on the
                                appropriate page on our Site summarizing the
                                transaction and requiring your authorization
                                before proceeding or through a separate written
                                agreement with you. By using the Reffy Platform,
                                you agree to pay all fees. Subject to applicable
                                law and as authorized by our agreements with
                                you, we reserve the right to adjust our pricing
                                and fees at any time. All payments between Users
                                will be processed through third-party payment
                                processors. We use Stripe as a third-party
                                payment processor and may use other
                                sub-processors. The processing of payments will
                                be subject to Stripe’s Service Agreement
                                (available at{' '}
                            </span>
                            <a href="https://stripe.com/ssa">
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        background: 'white',
                                    }}
                                >
                                    https://stripe.com/ssa
                                </span>
                            </a>
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    color: '#0A0B0D',
                                    background: 'white',
                                }}
                            >
                                ) and its Privacy Policy (available at{' '}
                            </span>
                            <a href="https://stripe.com/privacy">
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        background: 'white',
                                    }}
                                >
                                    https://stripe.com/privacy
                                </span>
                            </a>
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    color: '#0A0B0D',
                                    background: 'white',
                                }}
                            >
                                ), in addition to the Privacy Policy and these
                                Terms. We are not responsible for any errors by
                                Stripe. Furthermore, we are not responsible for
                                any payments between User.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    color: '#0A0B0D',
                                    background: 'white',
                                }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    12.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Subscription Terms
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . The ability to be listed as a Writer on the
                                Reffy Platform is available only to Users who
                                have created an account on the Reffy Platform.
                                If you are an individual Writer signing up for
                                access to the Reffy Platform (an “
                            </span>
                            <b>
                                <i>
                                    <span
                                        style={{
                                            fontSize: '11.0pt',
                                            color: '#444444',
                                        }}
                                    >
                                        Individual Subscriber
                                    </span>
                                </i>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                ”) you may be billed in advance on a recurring
                                and period basis (such as monthly, or annually)
                                depending on the type of subscription plan you
                                select when purchasing a subscription. If you
                                are purchasing a subscription on behalf of an
                                organization, then some terms of your
                                subscription may be governed by a separate
                                agreement in addition to these Terms.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                border: 'none',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                border: 'none',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                An Individual Subscriber may cancel a
                                subscription renewal either through the Writer
                                Account Page or by contacting the Company.
                                Individual Subscribers will not receive a refund
                                for the fees already paid for their current
                                subscription period and will be able to access
                                the Reffy Platform until the end of their
                                current subscription period. Except when
                                required by law, paid subscription fees are
                                non-refundable.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify', border: 'none' }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    color: '#0A0B0D',
                                    background: 'white',
                                }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    13.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Subscription Fee Changes
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . The Company, in its sole discretion and at any
                                time, may modify the fees charged to Individual
                                Subscribers. Any subscription fee change will
                                become effective at the end of the then-current
                                subscription period. The Company will provide
                                Individual Subscribers with reasonable prior
                                notice of any change in subscription fees. The
                                continued use of the Reffy Platform by an
                                Individual Subscriber after the subscription fee
                                change comes into effect constitutes agreement
                                to pay the modified subscription fee amount.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    14.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Your License to the Reffy Platform
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . Subject to your payment of applicable fees and
                                continued compliance with this Agreement and any
                                separate agreements we may have with you, we
                                hereby grant you a limited, non-exclusive,
                                revocable, non-transferable, non-sublicensable
                                license to access the Reffy Platform as
                                authorized in these Terms. Except for the
                                limited license to access the Reffy Platform
                                identified in the preceding paragraph, you
                                acknowledge that nothing contained in these
                                Terms shall be construed as granting or
                                conferring to you, by implication, estoppel or
                                otherwise, any right, title, or interest to any
                                intellectual property of the Company, our
                                third-party service providers or any other third
                                party, including any (a)&nbsp;inventions
                                (whether patentable or not in any country),
                                patents, patent applications, invention
                                disclosures, improvements, trade secrets,
                                proprietary information, know how, information,
                                or technical data; (b) copyright protected
                                works, copyright registrations, mask works, mask
                                work registrations or applications in the United
                                States or any foreign country; (c) trademarks,
                                trademark registrations, service marks, logos or
                                applications therefor in the United States or
                                any foreign country; (d) trade secrets; or
                                (e)&nbsp;any other tangible or intangible
                                proprietary rights anywhere in the world.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    15.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Restrictions On Use.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                {' '}
                                You agree that you will not:
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                distribute the Reffy Platform for any purpose,
                                including, without limitation, compiling an
                                internal database, redistributing or reproducing
                                the Reffy Platform by way of the press or media
                                or through any commercial network, cable or
                                satellite system;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                allow other individuals or entities to access
                                your account without the express written
                                permission of Reffy;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                create derivative works of, reverse engineer,
                                decompile, disassemble, adapt, translate,
                                transmit, arrange, modify, copy, bundle, sell,
                                sublicense, export, merge, transfer, adapt,
                                loan, rent, lease, assign, share, outsource,
                                host, publish, make available to any person or
                                otherwise use, either directly or indirectly,
                                the Reffy Platform in whole or in part, in any
                                form or by any means whatsoever, be they
                                physical, electronic or otherwise;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                permit, allow or do anything that would infringe
                                or otherwise prejudice the proprietary rights of
                                the Company or its licensors or allow any third
                                party to access the Reffy Platform;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                probe, scan or test the vulnerability of the
                                Reffy Platform and any system or network;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                breach or otherwise circumvent any security or
                                authentication measures;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                access, tamper with, or use non-public areas or
                                parts of the Reffy Platform, or shared areas of
                                the Reffy Platform you have not been invited to;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                access, search, or create accounts for the Reffy
                                Platform by any means other than our publicly
                                supported interfaces;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                promote or advertise products or services other
                                than your own without appropriate
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                authorization;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                circumvent storage space, usage, or transaction
                                limits for improper means, including attempting
                                to circumvent our fees;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                publish or share materials that are unlawful or
                                indecent, or that contain extreme acts of
                                violence or terrorist activity;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                advocate bigotry or hatred against any person or
                                group of people based on their race, religion,
                                ethnicity, sex, gender identity, sexual
                                orientation, disability, or impairment;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                harass or abuse our personnel or representatives
                                or agents performing services on
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                behalf of the Company;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                store, publish or share material that is
                                fraudulent, defamatory, or misleading; or
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                violate the law in any way.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ marginLeft: '.5in', border: 'none' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    16.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Platform Rules
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . In addition to the restrictions outlined in
                                Section 15, you must ensure that your use of our
                                Reffy Platform complies with certain platform
                                rules that we may publish or update from time to
                                time (the “
                                <b>
                                    <i>Platform Rules</i>
                                </b>
                                ”). If you are a Recipient, you agree that you
                                will not input any information onto the Reffy
                                Platform that would constitute a violation of
                                Section 15.&nbsp;{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    &nbsp;
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                If you do not agree to our Platform Rules, you
                                must immediately cease to use the Reffy
                                Platform. You understand that our Platform Rules
                                are binding and that in the event of your breach
                                of our Platform Rules or this Agreement we will
                                have discretion to take the following steps: (a)
                                terminate your account, (b) reduce and/or
                                suspend your access to the Reffy Platform, and
                                (c) remove your Content, with or without any
                                prior notice. For the avoidance of doubt, any
                                breach of the Platform Rules by you constitutes
                                a material breach of this Agreement.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    17.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Reffy’s Role
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . While we work hard to ensure our Users have
                                great experiences using the Reffy Platform, we
                                do not and cannot control the conduct of Users.
                                You acknowledge that Reffy has the right, but
                                does not have any obligation, to monitor the use
                                of the Reffy Platform and verify information
                                provided by our Users. For example, we may
                                review, disable access to, remove, or edit
                                Content to: (a) operate, secure and improve the
                                Reffy Platform (including for fraud prevention,
                                risk assessment, investigation and customer
                                support purposes); (b) ensure User compliance
                                with these Terms; (c) comply with applicable law
                                or the order or requirement of a court, law
                                enforcement or other administrative agency or
                                governmental body; (d) address Content that we
                                determine is harmful or objectionable; (e) take
                                actions set out in these Terms; and (f) maintain
                                and enforce any quality or eligibility criteria,
                                including by removing Recipient inputted content
                                that does not comply with these Terms. Users
                                acknowledge and agree that Reffy administers
                                these Terms, including decisions about whether
                                and how to apply them to a particular situation,
                                at its sole discretion. Users agree to cooperate
                                with and assist Reffy in good faith, and to
                                provide Reffy with such information and take
                                such actions as may be reasonably requested by
                                Reffy with respect to any investigation
                                undertaken by Reffy regarding the use or abuse
                                of the Reffy Platform. Reffy is not acting as an
                                agent for any User.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                                border: 'none',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    18.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Suspension.{' '}
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Without limiting our ability to terminate under
                                this Agreement or our right to change, modify,
                                suspend or discontinue the Reffy Platform at any
                                time as set forth elsewhere in these Terms, we
                                also reserve the right to cancel or suspend
                                transactions and/or the Reffy Platform due to
                                fraud or compliance-related concerns.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    19.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Third-Party Links and Services
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . The Reffy Platform may contain links to other
                                sites.&nbsp; The Company does not assume
                                responsibility for the accuracy or
                                appropriateness of the information, data,
                                opinions, advice or statements contained at such
                                sites, and when you access such sites, you are
                                doing so at your own risk.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    20.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Feedback.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                {' '}
                                If any User sends or transmits any
                                communications or materials to us by mail,
                                email, telephone, or otherwise, suggesting or
                                recommending changes to the Reffy Platform,
                                including, without limitation, new features or
                                functionality relating thereto, or any comments,
                                questions, suggestions, or the like (“
                                <b>
                                    <i>Feedback</i>
                                </b>
                                ”), we are free to use such Feedback and any
                                ideas, know-how, concepts, techniques, or other
                                intellectual property rights contained in the
                                Feedback, for any purpose whatsoever, without
                                any attribution or compensation to any party,
                                although we are not required to use any
                                Feedback.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    21.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Assumption of Risks
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                .
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                You understand, acknowledge, and freely assume
                                all risks relating to your access or use of the
                                Reffy Platform.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginLeft: '.75in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                &nbsp;
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                You understand and acknowledge there is no
                                guarantee that personal information and
                                transactions on the Reffy Platform or on the
                                internet will be maintained confidential and
                                secure.&nbsp; Your access or use of the Reffy
                                Platform is at your own risk, and that to the
                                maximum extent permitted by applicable law we
                                assume no liability or responsibility pertaining
                                to the Reffy Platform, your use of the Reffy
                                Platform or the receipt, storage, transmission
                                or other use of your personal information.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    22.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Indemnity.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                You agree to indemnify, defend and hold harmless
                                the Company, its agents, suppliers, licensors,
                                affiliates and their respective directors,
                                officers and employees (collectively, the “
                                <b>
                                    <i>Indemnified Parties</i>
                                </b>
                                ”) against all losses, liabilities, suits,
                                claims, actions, costs, damages and expenses
                                (including, without limitation, reasonable
                                attorneys’ fees and expenses) sustained,
                                incurred or paid by any Indemnified Party
                                directly or indirectly resulting from, arising
                                out of, relating to or in connection with: (a)
                                violation of these Terms by you, or other person
                                using your account or credentials; (b) alleged
                                and/or proven breach of applicable laws and/or
                                regulations by the Company; (c) your access to
                                or use of the Reffy Platform, (d) any
                                information used, stored, or transmitted in
                                connection with your account or credentials; (e)
                                breach of the rights of any third party,
                                including but not limited to privacy, publicity,
                                intellectual property, or other proprietary
                                rights, by you, or anyone using your account or
                                credentials; or (f) violation of any law,
                                regulation, or other legal requirement. This
                                paragraph is intended to be applicable to the
                                maximum extent allowed by law.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    23.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Limitations on Liability and Disclaimers.
                                </span>
                            </b>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    NO WARRANTIES.{' '}
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                EXCEPT AS EXPRESSLY PROVIDED IN A SEPARATE
                                AGREEMENT WITH YOU, THE REFFY PLATFORM IS
                                PROVIDED “AS IS” WITHOUT ANY REPRESENTATIONS,
                                WARRANTIES, GUARANTEES OR CONDITIONS, OF ANY
                                KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR
                                OTHERWISE, INCLUDING, BUT NOT LIMITED TO,
                                WARRANTIES AS TO UNINTERRUPTED OR ERROR-FREE
                                OPERATION, AVAILABILITY, ACCURACY, COMPLETENESS,
                                RELIABILITY, TIMELINESS, LEGALITY, SUITABILITY,
                                PRIVACY, SECURITY, MERCHANTABILITY, QUALITY,
                                TITLE, NON-INFRINGEMENT OR FITNESS FOR A
                                PARTICULAR PURPOSE, OR THOSE ARISING OUT OF A
                                COURSE OF DEALING OR USAGE OF TRADE.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    NO SPECIAL DAMAGES.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                {' '}
                                IN NO EVENT WILL THE COMPANY, ITS AFFILIATES,
                                AGENTS, LICENSORS, SUPPLIERS OR THEIR RESPECTIVE
                                DIRECTORS, OFFICERS OR EMPLOYEES BE LIABLE FOR
                                ANY SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE,
                                EXEMPLARY, AGGRAVATED, ECONOMIC OR CONSEQUENTIAL
                                DAMAGES, HOWSOEVER CAUSED, INCLUDING BUT NOT
                                LIMITED TO: DAMAGES FOR LOSS OF USE, LOST
                                PROFITS OR LOST SAVINGS, EVEN IF THE COMPANY OR
                                ANY OF ITS LAWFUL AGENTS OR EMPLOYEES HAVE BEEN
                                ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR
                                CLAIM.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    ADDITIONAL LIMITATION.{' '}
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                IN NO EVENT WILL COMPANY, ITS AFFILIATES,
                                AGENTS, LICENSORS, SUPPLIERS OR THEIR RESPECTIVE
                                DIRECTORS, OFFICERS OR EMPLOYEES BE LIABLE FOR
                                DAMAGES OR LOSSES RESULTING FROM: GOVERNMENT
                                ENFORCEMENT DUE TO REFFY’S FAILURE TO COMPLY
                                WITH APPLICABLE LAWS OR REGULATIONS, VIRUSES,
                                DATA CORRUPTION, FAILED MESSAGES, TRANSMISSION
                                ERRORS OR PROBLEMS; TELECOMMUNICATIONS SERVICE
                                PROVIDERS; LINKS TO THIRD PARTY WEBSITES;
                                PERSONAL INJURY; THIRD PARTY CONTENT, PRODUCTS
                                OR SERVICES; DAMAGES OR LOSSES CAUSED BY YOU OR
                                YOUR RESPECTIVE EMPLOYEES, AGENTS OR
                                SUBCONTRACTORS; THE USE OR INABILITY TO USE THE
                                SERVICES; ANY OTHER WEBSITE ACCESSED TO OR FROM
                                THE SERVICES; OR EVENTS BEYOND THE REASONABLE
                                CONTROL OF THE COMPANY, EVEN IF THE COMPANY OR
                                ANY OF ITS LAWFUL AGENTS OR EMPLOYEES HAVE BEEN
                                ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR
                                CLAIM.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    AGGREGATE LIABILITY
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . IN NO CASE WILL THE COMPANY'S, ITS
                                AFFILIATES', AGENTS', LICENSORS', AND THEIR
                                RESPECTIVE DIRECTORS', OFFICERS' AND EMPLOYEES'
                                CUMULATIVE TOTAL LIABILITY FOR ANY CAUSE
                                WHATSOEVER (INCLUDING WITHOUT LIMITATION BREACH
                                OF CONTRACT, TORT, NEGLIGENCE, GROSS NEGLIGENCE
                                OR OTHERWISE) ARISING UNDER OR RELATING TO THE
                                SERVICES BE MORE THAN THE VALUE OF THE FEES
                                ACTUALLY PAID TO US BY YOU DURING THE THREE (3)
                                MONTHS IMMEDIATELY PRECEDING THE DATE OF ANY
                                CLAIM GIVING RISE TO SUCH LIABILITY.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    24.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Term and Termination
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                .
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                We may, at any time and in our sole discretion,
                                without prior notice, and without any liability
                                to you, modify or discontinue any portion of the
                                Reffy Platform, either temporarily or
                                permanently.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                At any time and in our sole discretion, without
                                prior notice, and without any liability to you,
                                we may (a) cancel or deactivate your account; or
                                (b) temporarily or permanently, suspend,
                                restrict, or terminate access to any or all of
                                the Reffy Platform for any reason or for no
                                reason. &nbsp;We are under no obligations to
                                disclose its reason for any termination or
                                suspension of the Reffy Platform to you or
                                generally.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                In the event of any termination of this
                                Agreement, discontinuation of the Reffy
                                Platform, or termination of your right to access
                                the Reffy Platform: (i) all fees and amounts
                                payable to us by you shall immediately become
                                due, (ii) we may delete any of your User data
                                without any liability to you, provided that we
                                also reserve the right to retain your User data
                                for seven (7) years following termination; and
                                (iii) we may cancel any open transactions that
                                are pending at the time of the termination of
                                your right to access the Reffy Platform.&nbsp;
                                We reserve the right to retain aggregated
                                anonymized User data for longer to improve the
                                Reffy Platform, prevent fraud and produce
                                aggregated statistics.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.75in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '11.0pt',
                                    fontFamily: 'Symbol',
                                    color: '#444444',
                                }}
                            >
                                ·
                                <span
                                    style={{ font: '7.0pt "Times New Roman"' }}
                                >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                                </span>
                            </span>
                            <span dir="LTR" />
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                The provisions of these Terms relating to
                                indemnification, our limitations of liability
                                and disclaimers, your warranties and any other
                                provisions which by their terms should
                                reasonably survive termination, shall survive
                                termination of the Reffy Platform or this
                                Agreement.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    25.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Separate Agreement
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . From time to time, we may enter into separate
                                agreements to govern your use of the Reffy
                                Platform. Where the terms of such separate
                                agreement(s) conflict with these Terms, those
                                terms will prevail, but only to the extent they
                                conflict.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    26.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Notices
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . We may provide you with notices in any of the
                                following methods: (a) via the Reffy Platform,
                                including by a banner or pop-up within the
                                applicable Site,{' '}
                            </span>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                account or elsewhere; (b) by e-mail, sent to the
                                e-mail address you provided us; and/or (c)
                                through any other means, including any phone
                                number, SMS or text message or physical address
                                you provided us. Such notice to you will be
                                deemed received and effective upon receipt or
                                twenty-four (24) hours after it was published or
                                sent through any of the foregoing methods,
                                unless otherwise indicated in the notice. If we
                                choose to notify you through electronic
                                communication, you agree to receive such
                                communications, including but not limited to our
                                applicable policies, statements, reports,
                                invoices, receipts, disclosures, legal or
                                regulatory statements or documents via
                                electronic delivery.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    27.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;{' '}
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Binding Arbitration.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                {' '}
                                PLEASE READ THIS SECTION CAREFULLY, AS IT LIMITS
                                THE MANNER IN WHICH YOU MAY SEEK RELIEF, AND
                                REQUIRES YOU TO ARBITRATE DISPUTES WITH
                                US.&nbsp; If you have a dispute with us, we will
                                first seek to resolve such a dispute through our
                                support team.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Except for disputes in which either party seeks
                                equitable and other relief for the alleged
                                unlawful use of intellectual property,
                                copyrights, trademarks, trade names, logos,
                                trade secrets or patents, any dispute, claim or
                                controversy arising out of or relating to this
                                Agreement or the breach, termination,
                                enforcement, interpretation or validity thereof,
                                including the determination of the scope or
                                applicability of this Agreement to arbitrate,
                                will be determined by binding arbitration.&nbsp;
                                The location of the arbitration will be
                                determined by Reffy to be in either (a) the
                                state of your residence or (b) the county and
                                state of our chosen legal counsel at the time of
                                the dispute.&nbsp; The arbitration will be
                                administered by the American Arbitration
                                Association (AAA) in accordance with its
                                Commercial Arbitration Rules. Disputes will not
                                be resolved in any other forum or
                                venue.&nbsp;You agree that any arbitration will
                                be conducted by a sole arbitrator.
                                Pre-arbitration discovery will be limited to the
                                greatest extent provided by the rules of AAA,
                                the arbitration award will not include factual
                                findings or conclusions of law, and no punitive
                                damages will be awarded.&nbsp; Notwithstanding
                                any other rules, no arbitration proceeding
                                brought against Reffy will be consolidated with
                                any other arbitration proceeding without Reffy’s
                                written consent.&nbsp; Judgment may be entered
                                upon any award granted in any arbitration in any
                                court of competent jurisdiction in the county
                                and state in which Reffy maintains its principal
                                office at the time the award is rendered, in the
                                county and state where Reffy is organized or
                                incorporated or in any other court having
                                jurisdiction.&nbsp; The arbitrator will, in the
                                award, allocate all of the costs of the
                                arbitration, including the fees of the
                                arbitrator and the reasonable attorneys’ fees of
                                the prevailing party, against the party who did
                                not prevail.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                            }}
                        >
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                NOTICE:&nbsp; BOTH YOU AND REFFY ARE AGREEING TO
                                HAVE ALL DISPUTES, CLAIMS OR CONTROVERSIES
                                ARISING OUT OF OR RELATING TO THIS AGREEMENT
                                DECIDED BY NEUTRAL BINDING ARBITRATION AND ARE
                                GIVING UP ANY RIGHTS IT MIGHT POSSESS TO HAVE
                                THOSE MATTERS LITIGATED IN A COURT OR JURY
                                TRIAL.&nbsp; BY AGREEING TO THIS ARBITRATION
                                AGREEMENT, BOTH YOU AND REFFY ARE GIVING UP
                                THEIR RESPECTIVE JUDICIAL RIGHTS TO DISCOVERY
                                AND APPEAL EXCEPT TO THE EXTENT THAT THEY ARE
                                SPECIFICALLY PROVIDED FOR UNDER THIS
                                AGREEMENT.&nbsp; BY AGREEING TO ARBITRATION, YOU
                                ALSO GIVE UP YOUR RIGHT TO PARTICIPATE IN A
                                CLASS ACTION OR OTHER CLASS PROCEEDING. IF ANY
                                PARTY REFUSES TO SUBMIT TO ARBITRATION AFTER
                                AGREEING TO THIS PROVISION, THAT PARTY MAY BE
                                COMPELLED TO ARBITRATE UNDER FEDERAL OR STATE
                                LAW.&nbsp;THIS ARBITRATION AGREEMENT EVIDENCES A
                                TRANSACTION IN INTERSTATE COMMERCE, AND THUS TO
                                THE EXTENT APPLICABLE, THE U.S. FEDERAL
                                ARBITRATION ACT GOVERNS THE INTERPRETATION AND
                                ENFORCEMENT OF THIS PROVISION. BOTH YOU AND
                                REFFY CONFIRM THEIR AGREEMENT TO THIS
                                ARBITRATION PROVISION IS VOLUNTARY.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    28.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Governing law.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                This Agreement shall be governed pursuant to the
                                laws of the State of Delaware without regard to
                                principles of conflict of laws.&nbsp; you agree
                                that Reffy may initiate a proceeding related to
                                the enforcement or validity of Reffy’s
                                intellectual property rights in any court having
                                jurisdiction.&nbsp; With respect to any
                                proceeding that is not subject to arbitration
                                under this Agreement or policies incorporated
                                herein, you agree that any proceedings shall be
                                in the federal or state courts located in
                                Washington.&nbsp;You waive any objection to
                                venue and to submit to personal jurisdiction in
                                any such courts.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    29.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Interpretation.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                {' '}
                                The division of this Agreement into sections and
                                the insertion of headings are for convenience of
                                reference only and shall not affect the
                                construction or interpretation of this
                                Agreement. In this Agreement, words importing
                                the singular number include the plural and vice
                                versa; words importing gender include all
                                genders; and words importing persons include
                                individuals, sole proprietors, partnerships,
                                corporations, trusts and unincorporated
                                associations.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    30.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Entire Agreement.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                {' '}
                                This Agreement as it may be amended or modified
                                from time to time in accordance with these
                                Terms, and all other legal notices and policies
                                on this Site, constitutes the entire agreement
                                between you and the Company with respect to the
                                use of the Reffy Platform.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    31.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Amendment.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                The Company reserves the right, in its
                                discretion, to amend this Agreement at any time
                                by posting amendments on this Site. All
                                amendments made to these Terms will take
                                immediate effect. If any resulting amendment or
                                modification to these Terms requires Reffy to
                                interrupt, terminate, or cancel access to and/or
                                use of the Reffy Platform, then it shall have
                                the exclusive right to do so. You are
                                responsible for periodically reviewing the
                                amendments on this Site, and you are deemed to
                                be aware of such amendments. If you do not agree
                                to the amended terms and conditions, you shall
                                immediately stop using this Site. Access to this
                                Site or use of this Site after any amendments
                                have been posted shall constitute your
                                acknowledgement and acceptance of the amended
                                terms and conditions.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    32.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Severability
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . Any provision of this Agreement which is held
                                by a court of competent jurisdiction to be
                                illegal, invalid or unenforceable in such
                                jurisdiction shall, as to that jurisdiction, be
                                ineffective to the extent of such illegality,
                                invalidity or unenforceability and shall
                                otherwise be enforced to the maximum extent
                                permitted by law, all without affecting the
                                remaining provisions of this Agreement or
                                affecting the legality, validity or
                                enforceability of such provision in any other
                                jurisdiction.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    33.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Inurement.
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                This Agreement shall inure to the benefit of and
                                be binding upon each of us and our respective
                                successors and permitted assigns. You
                                acknowledge having read this Agreement before
                                accepting it, having the authority to accept
                                this Agreement and having received a copy of
                                this Agreement.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    34.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Assignment
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                . You shall not assign or transfer any of your
                                rights or obligations under this Agreement
                                without our prior written consent, which we may
                                withhold at our sole and absolute
                                discretion.&nbsp; Any actual or attempted
                                assignment hereof by you contrary to the terms
                                of this Agreement shall be null and void.&nbsp;
                                We may, at our discretion, assign some or all
                                our rights or obligations to a third party,
                                without your consent or approval.&nbsp; If we
                                are acquired by, sold to, or merged with a
                                third-party entity, we reserve the right to
                                transfer or assign all your User data as part of
                                such merger, acquisition, sale, or change of
                                control.
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginTop: '0in',
                                marginRight: '0in',
                                marginBottom: '12.0pt',
                                marginLeft: '.25in',
                                textAlign: 'justify',
                                textIndent: '-.25in',
                            }}
                        >
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    35.
                                    <span
                                        style={{
                                            font: '7.0pt "Times New Roman"',
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </span>
                            </b>
                            <span dir="LTR" />
                            <b>
                                <span
                                    style={{
                                        fontSize: '11.0pt',
                                        color: '#444444',
                                    }}
                                >
                                    Support.{' '}
                                </span>
                            </b>
                            <span
                                style={{ fontSize: '11.0pt', color: '#444444' }}
                            >
                                Please direct questions, complaints, or issues
                                to support@refbuilder.com.{' '}
                            </span>
                        </p>
                        <p
                            className="MsoNormal"
                            style={{
                                marginBottom: '12.0pt',
                                textAlign: 'justify',
                            }}
                        >
                            &nbsp;
                        </p>
                        <p
                            className="MsoNormal"
                            style={{ textAlign: 'justify' }}
                        >
                            &nbsp;
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
